import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { ArrowLeft } from "@material-ui/icons";
import React from "react";
import { useHistory } from "react-router-dom";
import { pageTitleStyles } from "../../../mui/styles";
import { useCompany } from "../../../contexts/CompanyContext";

/**
 * LevelSettings component allows users to manage dealer levels.
 * It provides functionality to view existing levels and add new levels.
 *
 * @component
 * @returns {React.Element} The rendered component.
 *
 * @example
 * <LevelSettings />
 *
 * @function
 * @name LevelSettings
 *
 * @description
 * This component uses several hooks:
 * - `useHistory` from `react-router-dom` to navigate back to the settings page.
 * - `useState` to manage component state for dialog open/close, level name, level, loading, and error.
 * - `useCompany` custom hook to get dealer levels and upsertDealerLevel function.
 *
 * @typedef {object} DealerLevel
 * @property {string} id - The unique identifier of the dealer level.
 * @property {string} level_name - The name of the dealer level.
 *
 * @typedef {object} UpsertDealerLevelParams
 * @property {number} level - The level number.
 *
 * @async
 * @function handleSubmit
 * @description Handles the submission of the new dealer level form.
 * It sets the loading state, calls the upsertDealerLevel function, and handles any errors.
 *
 * @returns {Promise<void>}
 */
export default function LevelSettings() {
  const history = useHistory();
  const { leaderLevels: levels } = useCompany();

  const levelsMap = levels.map(level => (
    <TableRow key={level.id}>
      <TableCell>{level.name}</TableCell>
      <TableCell>{level.id}</TableCell>
      <TableCell>{level.description}</TableCell>
    </TableRow>
  ));

  return (
    <div>
      <Button
        startIcon={<ArrowLeft />}
        color="primary"
        onClick={() => history.push("/settings")}
      >
        Back
      </Button>
      <h1 style={pageTitleStyles}>Level Settings</h1>
      <br />
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Level Name</TableCell>
              <TableCell>Level</TableCell>
              <TableCell>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{levels && levelsMap}</TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
